import React from 'react';
import { MessageCircle } from 'lucide-react';
import { clubInfo } from '../mockData';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi! I'm interested in joining NexGen MMA Club. Can you provide more information?");
    window.open(`https://wa.me/${clubInfo.phone}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110 active:scale-95 flex items-center justify-center group"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle size={28} className="group-hover:animate-pulse" />
    </button>
  );
};

export default WhatsAppButton;
